/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponseOfPtw100BadRequestException,
  ErrorResponseOfPtw100MaintenanceModeException,
  FileNameInfoDto,
  ProblemDetails,
} from '../models/index';
import {
    ErrorResponseOfPtw100BadRequestExceptionFromJSON,
    ErrorResponseOfPtw100BadRequestExceptionToJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionToJSON,
    FileNameInfoDtoFromJSON,
    FileNameInfoDtoToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/index';

export interface GetCsvFileRequest {
    identifier: string;
}

export interface GetSelectedCsvFileRequest {
    masterDeviceId: string;
}

export interface GetSelectedCsvFileNameRequest {
    masterDeviceId: string;
}

export interface SelectCsvFileRequest {
    masterDeviceId: string;
    identifier: string;
}

/**
 * 
 */
export class UnicheckSimulatorApi extends runtime.BaseAPI {

    /**
     */
    async getCsvFileRaw(requestParameters: GetCsvFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['identifier'] == null) {
            throw new runtime.RequiredError(
                'identifier',
                'Required parameter "identifier" was null or undefined when calling getCsvFile().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/simulator/unicheck/csv/{identifier}`.replace(`{${"identifier"}}`, encodeURIComponent(String(requestParameters['identifier']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
						return new runtime.BlobApiResponse(response);
					}
          case 400: { 
						return new runtime.BlobApiResponse(response);
					}
          case 403: { 
						return new runtime.BlobApiResponse(response);
					}
          case 404: { 
						return new runtime.BlobApiResponse(response);
					}
					default: {
						return new runtime.BlobApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     */
     async getCsvFile(requestParameters: GetCsvFileRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<UnicheckSimulatorApi['getCsvFileRaw']>>, Blob>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = Blob;

         const response = this.getCsvFileRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getCsvFilesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/simulator/unicheck/csv`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
						return new runtime.JSONApiResponse<any>(response);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
					default: {
						return new runtime.JSONApiResponse<any>(response);
					}
				}
				// -- Responses
    }

    /**
     */
     async getCsvFiles(errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<UnicheckSimulatorApi['getCsvFilesRaw']>>, Array<string>>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = Array<string>;

         const response = this.getCsvFilesRaw(initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getSelectedCsvFileRaw(requestParameters: GetSelectedCsvFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['masterDeviceId'] == null) {
            throw new runtime.RequiredError(
                'masterDeviceId',
                'Required parameter "masterDeviceId" was null or undefined when calling getSelectedCsvFile().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/simulator/unicheck/csv/selected/{masterDeviceId}`.replace(`{${"masterDeviceId"}}`, encodeURIComponent(String(requestParameters['masterDeviceId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
						return new runtime.BlobApiResponse(response);
					}
          case 400: { 
						return new runtime.BlobApiResponse(response);
					}
          case 403: { 
						return new runtime.BlobApiResponse(response);
					}
          case 404: { 
						return new runtime.BlobApiResponse(response);
					}
					default: {
						return new runtime.BlobApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     */
     async getSelectedCsvFile(requestParameters: GetSelectedCsvFileRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<UnicheckSimulatorApi['getSelectedCsvFileRaw']>>, Blob>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = Blob;

         const response = this.getSelectedCsvFileRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getSelectedCsvFileNameRaw(requestParameters: GetSelectedCsvFileNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['masterDeviceId'] == null) {
            throw new runtime.RequiredError(
                'masterDeviceId',
                'Required parameter "masterDeviceId" was null or undefined when calling getSelectedCsvFileName().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/simulator/unicheck/csv/selected/{masterDeviceId}/name`.replace(`{${"masterDeviceId"}}`, encodeURIComponent(String(requestParameters['masterDeviceId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => FileNameInfoDtoFromJSON(jsonValue), "FileNameInfoDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => FileNameInfoDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     */
     async getSelectedCsvFileName(requestParameters: GetSelectedCsvFileNameRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<UnicheckSimulatorApi['getSelectedCsvFileNameRaw']>>, FileNameInfoDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = FileNameInfoDto;

         const response = this.getSelectedCsvFileNameRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async selectCsvFileRaw(requestParameters: SelectCsvFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['masterDeviceId'] == null) {
            throw new runtime.RequiredError(
                'masterDeviceId',
                'Required parameter "masterDeviceId" was null or undefined when calling selectCsvFile().'
            );
        }


        if (requestParameters['identifier'] == null) {
            throw new runtime.RequiredError(
                'identifier',
                'Required parameter "identifier" was null or undefined when calling selectCsvFile().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/simulator/unicheck/csv/selected/{masterDeviceId}/{identifier}`.replace(`{${"masterDeviceId"}}`, encodeURIComponent(String(requestParameters['masterDeviceId']))).replace(`{${"identifier"}}`, encodeURIComponent(String(requestParameters['identifier']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 202: { 
							return new runtime.VoidApiResponse(response);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ProblemDetailsFromJSON(jsonValue), "ProblemDetails" as const);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     */
     async selectCsvFile(requestParameters: SelectCsvFileRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<UnicheckSimulatorApi['selectCsvFileRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.selectCsvFileRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

}
